if (!customElements.get('range-filter')) {
  class RangeFilter extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      this.minNumberInput = document.querySelector('[id$="range-filter-number-min"]');
      this.minSliderInput = document.querySelector('[id$="range-filter-slider-min"]');
      this.minValue = Number(this.minNumberInput.min);
      this.type = this.minNumberInput.dataset.type

      if (this.type != "slider") {
        this.maxNumberInput = document.querySelector('[id$="range-filter-number-max"]');
        this.maxSliderInput = document.querySelector('[id$="range-filter-slider-max"]');
        this.maxValue = Number(this.maxNumberInput.max);
      }
      
      this.timeout = null;
      this.addEventListener('input', this.handleInput.bind(this));
    }

    /**
     * Handles 'input' events on the price range component.
     * @param {object} evt - Event object.
     */
    handleInput(evt) {
      if (evt.detail !== undefined) {
        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          this.updateSliderInputs(evt);
          this.updateNumberInputs();
        }, 500);
      } else {
        this.updateSliderInputs(evt);
        this.updateNumberInputs();
      }
    }

    /**
     * Updates the value of the 'number' type inputs.
     */
    updateNumberInputs() {
      if (this.type != "slider") { 
      this.minNumberInput.value = (this.minSliderInput.value == this.minNumberInput.min && this.maxSliderInput.value == this.maxNumberInput.max)
        ? null : this.minSliderInput.value;

      this.maxNumberInput.value = (this.maxSliderInput.value == this.maxNumberInput.max && this.minSliderInput.value == this.minNumberInput.min)
        ? null : this.maxSliderInput.value;
      } else {
        this.minNumberInput.value = this.minSliderInput.value;
      }
      
    }

    /**
     * Updates the value of the 'range' type inputs.
     * @param {object} evt - Event object.
     */
    updateSliderInputs(evt) {
      
      const minValue = parseInt(this.minNumberInput.value);
      const maxValue = this.type == "slider" ? minValue : parseInt(this.maxNumberInput.value);

      if (minValue > maxValue) {
        if (evt.target === this.minNumberInput) {
          this.maxSliderInput.value = minValue;

          if (maxValue === this.maxValue) {
            this.minSliderInput.value = this.maxValue;
          }
        } else {
          this.minSliderInput.value = maxValue;
        }
      }

      if (maxValue < minValue) {
        if (evt.target === this.maxNumberInput) {
          this.minSliderInput.value = maxValue;

          if (minValue === this.minValue) {
            this.maxSliderInput.value = maxValue;
          }
        } else {
          this.maxSliderInput.value = minValue;
        }
      }

      if (evt.target === this.minNumberInput) {
        this.minSliderInput.value = minValue || Number(this.minNumberInput.min);
      }

      if (evt.target === this.maxNumberInput) {
        this.maxSliderInput.value = maxValue || Number(this.maxNumberInput.max);
      }
    }
  }

  customElements.define('range-filter', RangeFilter);
}
